import { render } from "./PortalTurnoPacienteCard.vue?vue&type=template&id=33d7a1aa&scoped=true"
import script from "./PortalTurnoPacienteCard.vue?vue&type=script&lang=js"
export * from "./PortalTurnoPacienteCard.vue?vue&type=script&lang=js"

import "./PortalTurnoPacienteCard.vue?vue&type=style&index=0&id=33d7a1aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d7a1aa"]])

export default __exports__